// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React, { useLayoutEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import App from './app';
import Authoring from './pages/authoring';
import CourseCatalog from './pages/course-catalog';
import CourseInfo from './pages/course-info';
import Docs from './pages/docs';
import Domains from './pages/domains';
import ErrorPage from './pages/error';
import Home from './pages/home';
import HTMLPage from './pages/html';
import MyWork from './pages/my-work';
import WhatsNew from './pages/whats-new';

// Application routes.
export default () => {
    const location = useLocation();

    useLayoutEffect(() => {
        const content = document.getElementById('main-content');
        if (content) {
            content.focus();
            content.blur();
        }
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <Routes>
            <Route path="/" element={<App />}>
                <Route index element={<Home />} />
                <Route path="my-work">
                    <Route path="" element={<MyWork />} />
                    <Route path=":tabName">
                        <Route path="" element={<MyWork />} />
                        <Route path="new" element={<MyWork />} />
                    </Route>
                </Route>
                <Route path="courses">
                    <Route path="" element={<CourseCatalog />} />
                    <Route path=":courseId" element={<CourseInfo />} />
                </Route>
                <Route path="release-notes" element={<Navigate to="/whats-new" />} />
                <Route path="whats-new">
                    <Route path="" element={<WhatsNew />} />
                    <Route path=":postId" element={<WhatsNew />} />
                </Route>
                <Route path="educators" element={<Docs src="/docs/educators.md" />} />
                <Route path="authoring">
                    <Route path="" element={<Authoring />} />
                    <Route path="new" element={<Authoring />} />
                    <Route path="link" element={<Authoring />} />
                    <Route path="redirect" element={<Navigate to="/authoring" state="account-linked" />} />
                </Route>
                <Route path="faq" element={<Docs src="/docs/faq.md" />} />
                <Route path="domains" element={<Domains />} />
                <Route path="report" element={<Home />} />
                <Route path="feedback" element={<Home />} />
                <Route path="redirect" element={<Navigate to="/" state="signin-error" replace />} />
                <Route path="signin" element={<Navigate to="/" state="signin-error" replace />} />
                <Route path="github-redirect" element={<Navigate to="/" state="github-error" replace />} />
                <Route path="error" element={<ErrorPage />} />
                <Route
                    path="notice"
                    element={
                        <HTMLPage
                            src="/html/NOTICE.html"
                            title="Third Party Notices"
                            iframeStyle={{ backgroundColor: 'white' }}
                        />
                    }
                />
                {
                    /* If we fall through everything we have a share link failure, so render a toast for that */
                    <Route path="*" element={<Navigate to="/" state="sharelink-error" replace />} />
                }
            </Route>
        </Routes>
    );
};
